var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-button',{directives:[{name:"indexed",rawName:"v-indexed"}],attrs:{"type":"primary","icon":"el-icon-fa-file-certificate fas","size":_vm.size,"loading":_vm.loading},on:{"click":_vm.handleMyAreaRedirect}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t('login.licenceExpired.buy')))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }